import React from "react";

const Extra = ({ element }) => {
  return <>{element}</>;
};

export default Extra;
